exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-col-content.two-lines {\n  line-height: 30px;\n  align-items: flex-start;\n  width: 100%; }\n\n.kube-status-container {\n  display: flex;\n  align-items: center; }\n  .kube-status-container .kube-status-desc {\n    margin-left: 6px;\n    width: 100%; }\n\n.item-top-padding {\n  margin-top: 8px; }\n\n.image-details-content .image-details-header .image-details-back-button {\n  cursor: pointer; }\n\n.image-details-card .image-full-details-table {\n  padding-bottom: 16px; }\n\n.image-layers-card .bolt-header-default {\n  padding-bottom: 12px; }\n", ""]);

// exports
